import React from 'react';

const Payment = () => (
  <div className="container mx-auto py-10">
    <h1 className="text-3xl font-bold mb-4">Paiement sécurisé</h1>
    <p>Module de paiement à intégrer (Stripe, Paypal, etc.).</p>
    <p>Contactez-nous pour finaliser votre souscription.</p>
  </div>
);

export default Payment;
